import { ActionType } from "../action-types/type";
import { Dispatch } from "redux";

export const setAppLanguage =
  (appLanguage: string, data: any) => (dispatch: Dispatch) => {
    return dispatch({
      type: ActionType.SET_APP_LANGUAGE,
      payload: { languageId: appLanguage, data: data },
    });
  };
